<template>
  <ValidationObserver v-slot="{ handleSubmit, reset }">
    <b-form ref="productForm" @submit.prevent="handleSubmit(save)" @reset.prevent="reset">
      <div class="row">
        <div class="col-lg-6">
          <div class="card">
            <div class="card-body">
              <div>
                <b-row>
                  <label v-if="(campaignId <= 0 || isNaN(campaignId)) && !eloadTopupsModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a campaign.</label>
                  <label v-else-if="campaignId > 0 && !eloadTopupsModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a campaign.</label>
                  <b-col sm="12" class="mb-3">
                    <label class="form-label small fw-bold"
                      >E-Load SKU Tab<span class="red">*</span></label
                    >
                    <validation-provider
                      name="eload SKU"
                     rules="required"
                      v-slot="validationContext"
                    >
                      <!-- <b-form-select
                        :state="getValidationState(validationContext)"
                        class="form-control" 
                        placeholder="Select Eload SKU"
                        v-model="campaignDetails.skuId"
                        :options="skuOptions"
                      /> -->
                      <multiselect 
                        v-model="campaignDetails.skuId" 
                        placeholder="Select Eload SKU" 
                        label="text" 
                        track-by="value" 
                        :options="skuOptions" 
                        :multiple="true"
                        :allow-empty="true"
                        :preselect-first="false"
                        :state="getValidationState(validationContext)">
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title me-1">{{ props.option.text }}</span>
                          </div>
                        </template>
                      </multiselect>
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" class="mb-3">
                    <!-- @click="retrieveMopOpts" -->
                    <label class="form-label small fw-bold" 
                      >Mode of Payment </label
                    >
                    <!-- <span class="red">*</span> -->
                    <validation-provider
                      name="eloadMOP"
                      v-slot="{ errors, ariaMsg }"
                    >
                      <!-- rules="required" -->
                      <multiselect 
                        v-model="campaignDetails.mopDetailIds" 
                        placeholder="Select Mode of Payment" 
                        label="displayName" 
                        track-by="methodId" 
                        :options="mopOptions" 
                        :multiple="true"
                        :allow-empty="true"
                        :preselect-first="false">
                        <!-- :class="{
                          invalid: errors[0],
                        }" -->
                        <template slot="singleLabel" slot-scope="props">
                          <span class="option__desc">
                            <span class="option__title">{{ props.option.displayName }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__small font-size-12 float-end">{{ props.option.remarks }}</span>
                            <span class="option__title me-1">{{ props.option.displayName }}</span>
                            <span class="option__small font-size-12 badge badge-outline-primary me-1 badge-secondary badge-pill">
                              Min. Amount: {{ props.option.minAmountRequired }}
                            </span>
                            <span class="option__small font-size-12 badge badge-outline-primary me-1 badge-secondary badge-pill" v-if="!props.option['$isDisabled']">
                              Rebate: {{ props.option.rebatePercentage }}%
                            </span>
                          </div>
                        </template>
                      </multiselect>
                      <b-form-invalid-feedback v-bind="ariaMsg">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" class="mb-3">
                    <label class="form-label small fw-bold"
                      >Promo Name</label
                    >
                      <b-form-input
                        type="text"
                        v-model="campaignDetails.promoName"
                        class="form-control"
                        placeholder=""
                      />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" class="mb-3">
                    <label class="form-label small fw-bold"
                      >Promo Rebate<span class="red">*</span></label
                    >
                    <validation-provider
                      name="promo rebate"
                     :rules="ruleObject2"
                      v-slot="validationContext"
                    >
                      <b-form-input
                        type="number"
                        step="0.01"
                        :state="getValidationState(validationContext)"
                        v-model="campaignDetails.promoRebate"
                        class="form-control"
                        placeholder="0%"
                        min="0"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label class="form-label small fw-bold">
                      Promo Start Date & Time
                      <span class="red">*</span>
                    </label>
                  </b-col>
                  <b-col>
                    <label class="form-label small fw-bold">
                      Promo End Date & Time
                      <span class="red">*</span>
                    </label>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <validation-provider
                      name="promo start date"
                      :rules="ruleObject"
                      v-slot="validationContext"
                    > 
                      <input type="hidden" :state="getValidationState(validationContext)" v-model="campaignDetails.promoStartDate" class="form-control"/>
                      <date-picker 
                        class="mb-2"
                        :class="{'is-invalid': getValidationState(validationContext) === false }"
                        :config="datePickerStartOptions"
                        :state="getValidationState(validationContext)"
                        v-model="promoStart"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <validation-provider
                      name="promo end date"
                     :rules="ruleObject"
                      v-slot="validationContext"
                    >
                      <input type="hidden" :state="getValidationState(validationContext)" v-model="campaignDetails.promoEndDate" class="form-control"/>
                      <date-picker 
                        :disabled="!promoEnd"
                        class="mb-2"
                        :class="{'is-invalid': getValidationState(validationContext) === false }"
                        :config="datePickerEndOptions"
                        :state="getValidationState(validationContext)"
                        v-model="promoEnd"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" class="mb-3">
                    <label class="form-label small fw-bold"
                      >User who can avail<span class="red">*</span></label
                    >
                    <b-row>
                      <b-col md="8" sm="8">
                        <validation-provider
                          name="product name"
                          :rules="ruleObject"
                          v-slot="validationContext"
                        >
                          <b-form-select
                            class="form-control" 
                            @change="updateSettings"
                            v-model="campaignDetails.promoRequirement"
                            :options="requirementOptions"
                          />
                          <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </b-col>
                      <b-col md="4" sm="4">
                        <b-button @click="customize" type="button" class="w-100">Customize</b-button>
                      </b-col>
                    </b-row>
                    
                  </b-col>
                </b-row>
                <!-- Behavioral settings -->
                <div class="mb-4" v-if="!isNotCustom" :class="{ 'disable-setting' : isNotCustom }">
                  <b-row v-if="false">
                    <b-col sm="12">
                      <label class="form-label small fw-bold"
                        >Custom Behavioral Settings</label
                      >   
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" class="mb-2">
                      <label class="form-label small fw-bold"
                        >Custom Segment Name<span class="red">*</span></label
                      >
                      <validation-provider
                        name="segment name"
                        :rules="ruleObject"
                        v-slot="validationContext"
                      >
                        <b-form-input
                          type="text"
                          :state="getValidationState(validationContext)"
                          v-model="campaignDetails.segmentName"
                          class="form-control"
                          placeholder="Segment name"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <div class="border rounded px-3">
                        <div class="float-end pt-2">
                          <toggle-button
                            :height="20"
                            :width="40"
                            v-model="campaignDetails.behaviorSettings.saveAsPreset"
                            color="#e73092"
                            :sync="true"
                          />
                        </div>
                        <label class="form-label small fw-bold pt-2">
                          Save as Preset
                        </label>
                      </div>
                    </b-col>
                  </b-row>
                  <!-- Verified User -->
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <div class="border rounded px-3">
                        <div class="float-end pt-2">
                          <toggle-button
                            :height="20"
                            :width="40"
                            v-model="campaignDetails.behaviorSettings.isUserVerified"
                            color="#e73092"
                            :sync="true"
                          />
                        </div>
                        <label class="form-label small fw-bold pt-2">
                          Verified User
                        </label>
                      </div>
                    </b-col>
                  </b-row>
                  <!-- Verified Kankolek User -->
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <div class="border rounded px-3">
                        <div class="float-end pt-2">
                          <toggle-button
                            :height="20"
                            :width="40"
                            v-model="campaignDetails.behaviorSettings.isKankolekUserVerified"
                            color="#e73092"
                            :sync="true"
                          />
                        </div>
                        <label class="form-label small fw-bold pt-2">
                          Verified Kankolek User
                        </label>
                      </div>
                    </b-col>
                  </b-row>
                  <!-- Purchase and balance -->
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <div class="border rounded px-3">
                        <div class="col-12">
                          <div class="float-end pt-2">
                            <toggle-button
                              :height="20"
                              :width="40"
                              v-model="campaignDetails.behaviorSettings.hasBalanceQualifier"
                              color="#e73092"
                              :sync="true"
                            />
                          </div>
                          <label class="form-label small fw-bold pt-2">
                            Wallet Balance
                          </label>
                        </div>
                        <div class="col-12" v-if="campaignDetails.behaviorSettings.hasBalanceQualifier">
                          <div class="row w-100 mb-3">
                            <div class="col-6 pe-0">
                              <validation-provider
                                name="min value"
                                :rules="ruleObject2"
                                v-slot="validationContext"
                              >
                                <b-form-input
                                  :class="{'is-invalid': getValidationState(validationContext) === false }"
                                  v-model="campaignDetails.behaviorSettings.balanceSetting.minBalance"
                                  type="number"
                                  step="0"
                                  class="form-control"
                                  placeholder="Minimum value"
                                  min="0"
                                />
                                <b-form-invalid-feedback>
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </validation-provider>
                            </div>
                            <div class="col-6 pe-0">
                              <validation-provider
                                name="max value"
                                :rules="{required: true,min_value:campaignDetails.behaviorSettings.balanceSetting.minBalance}"
                                v-slot="validationContext"
                              >
                                <b-form-input
                                  :class="{'is-invalid': getValidationState(validationContext) === false }"
                                  v-model="campaignDetails.behaviorSettings.balanceSetting.maxBalance"
                                  type="number"
                                  step="0"
                                  class="form-control"
                                  placeholder="Maximum value"
                                  min="0"
                                />
                                <b-form-invalid-feedback>
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </validation-provider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <!-- Topup Settings -->
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <div class="border rounded px-3">
                        <div class="float-end pt-2">
                          <toggle-button
                            :height="20"
                            :width="40"
                            v-model="campaignDetails.behaviorSettings.hasTopupQualifier"
                            color="#e73092"
                            :sync="true"
                          />
                        </div>
                        <label class="form-label small fw-bold pt-2">
                          Topup
                        </label>

                        <setting-box
                          v-if="campaignDetails.behaviorSettings.hasTopupQualifier"
                          v-model="campaignDetails.behaviorSettings.topupSetting"
                        />
                      </div>
                    </b-col>
                  </b-row>
                  <!-- Rewards Settings -->
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <div class="border rounded px-3">
                        <div class="float-end pt-2">
                          <toggle-button
                            :height="20"
                            :width="40"
                            v-model="campaignDetails.behaviorSettings.hasRewardsQualifier"
                            color="#e73092"
                            :sync="true"
                          />
                        </div>
                        <label class="form-label small fw-bold pt-2">
                          Rewards
                        </label>

                        <setting-box
                          v-if="campaignDetails.behaviorSettings.hasRewardsQualifier"
                          v-model="campaignDetails.behaviorSettings.rewardSetting"
                        />
                      </div>
                    </b-col>
                  </b-row>
                  <!-- Sell Eload Settings -->
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <div class="border rounded px-3">
                        <div class="float-end pt-2">
                          <toggle-button
                            :height="20"
                            :width="40"
                            v-model="campaignDetails.behaviorSettings.hasSellEloadQualifier"
                            color="#e73092"
                            :sync="true"
                          />
                        </div>
                        <label class="form-label small fw-bold pt-2">
                          Sell ELoad
                        </label>

                        <setting-box
                          v-if="campaignDetails.behaviorSettings.hasSellEloadQualifier"
                          v-model="campaignDetails.behaviorSettings.sellEloadSetting"
                        />
                      </div>
                    </b-col>
                  </b-row>
                  <!-- Kankolek Settings -->
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <div class="border rounded px-3">
                        <div class="float-end pt-2">
                          <toggle-button
                            :height="20"
                            :width="40"
                            v-model="campaignDetails.behaviorSettings.hasKankolekQualifier"
                            color="#e73092"
                            :sync="true"
                          />
                        </div>
                        <label class="form-label small fw-bold pt-2">
                          Kankolek
                        </label>

                        <setting-box
                          type="kankolek"
                          v-if="campaignDetails.behaviorSettings.hasKankolekQualifier"
                          v-model="campaignDetails.behaviorSettings.KankolekSetting"
                        />
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <!-- End behavioral settings -->
                <b-row>
                  <b-col cols="4">
                    <label class="form-label small fw-bold">
                      Promo Stock Allocated
                    </label>
                  </b-col>
                  <b-col cols="2" class="d-flex justify-content-end">
                    <toggle-button
                      :height="20"
                      :width="40"
                      v-model="stockOption"
                      color="#e73092"
                      :sync="true"
                    />
                  </b-col>
                  <b-col>
                    <template v-if="(campaignDetails.promoDistribution).includes('s')">
                      <validation-provider
                        name="promo stock"
                        :rules="{ ...ruleObject, min_value: 1 }"
                        v-slot="validationContext"
                      >
                        <div class="input-group">
                          <b-form-input
                            :disabled="!(campaignDetails.promoDistribution).includes('s')"
                            type="number"
                            step="1"
                            class="form-control"
                            :state="getValidationState(validationContext)"
                            v-model="campaignDetails.promoStock"
                            placeholder="Type number"
                          />
                          <span class="input-group-text">Quantity</span>
                        </div>
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </template>
                    <template v-if="!(campaignDetails.promoDistribution).includes('s')">
                      <div class="input-group">
                        <b-form-input
                          :disabled="!(campaignDetails.promoDistribution).includes('s')"
                          type="number"
                          step="1"
                          class="form-control"
                          v-model="campaignDetails.promoStock"
                          placeholder="Type number"
                        />
                        <span class="input-group-text">Quantity</span>
                      </div>
                    </template>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <label class="form-label small fw-bold">
                      Availment frequency per users
                    </label>
                  </b-col>
                  <b-col cols="2" class="d-flex justify-content-end">
                    <toggle-button
                      :height="20"
                      :width="40"
                      v-model="frequencyOption"
                      color="#e73092"
                      :sync="true"
                    />
                  </b-col>
                  <b-col>
                    <template v-if="(campaignDetails.promoDistribution).includes('f')">
                      <validation-provider
                        name="promo frequency"
                        :rules="{ ...ruleObject, min_value: 1 }"
                        v-slot="validationContext"
                      >
                        <div class="input-group">
                          <b-form-input
                            :disabled="!(campaignDetails.promoDistribution).includes('f')"
                            type="number"
                            step="1"
                            class="form-control"
                            :state="getValidationState(validationContext)"
                            v-model="campaignDetails.promoFrequency"
                            placeholder="Type number"
                          />
                          <span class="input-group-text">Quantity</span>
                        </div>
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </template>
                    <template v-if="!(campaignDetails.promoDistribution).includes('f')">
                      <div class="input-group">
                        <b-form-input
                          :disabled="!(campaignDetails.promoDistribution).includes('f')"
                          type="number"
                          step="1"
                          class="form-control"
                          v-model="campaignDetails.promoFrequency"
                          placeholder="Type number"
                        />
                        <span class="input-group-text">Quantity</span>
                      </div>
                    </template>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <label class="form-label small fw-bold">
                      Promo Cap
                    </label>
                  </b-col>
                  <b-col cols="2" class="d-flex justify-content-end">
                    <toggle-button
                      :height="20"
                      :width="40"
                      v-model="capOption"
                      color="#e73092"
                      :sync="true"
                    />
                  </b-col>
                  <b-col>
                    <template v-if="(campaignDetails.promoDistribution).includes('ca')">
                      <validation-provider
                        name="promo cap"
                        :rules="{ ...ruleObject, min_value: 1 }"
                        v-slot="validationContext"
                      >
                        <div class="input-group">
                          <b-form-input
                            :disabled="!(campaignDetails.promoDistribution).includes('ca')"
                            type="number"
                            step="1"
                            class="form-control"
                            :state="getValidationState(validationContext)"
                            v-model="campaignDetails.promoCap"
                            placeholder="Type number"
                          />
                          <span class="input-group-text">Amount</span>
                        </div>
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </template>
                    <template v-if="!(campaignDetails.promoDistribution).includes('ca')">
                      <div class="input-group">
                        <b-form-input
                          :disabled="!(campaignDetails.promoDistribution).includes('ca')"
                          type="number"
                          step="1"
                          class="form-control"
                          v-model="campaignDetails.promoCap"
                          placeholder="Type number"
                        />
                        <span class="input-group-text">Amount</span>
                      </div>
                    </template>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                    <b-col class="d-flex align-items-center">
                      <div class="draft-link" @click="saveAsDraft" :disabled="campaignId > 0 ? !eloadTopupsModule.access.update : !eloadTopupsModule.access.create">SAVE AS DRAFT</div>
                    </b-col>
                    <b-col
                      ><b-btn class="w-100 btn btn-light"
                        @click="goToList"
                        >Cancel</b-btn
                      ></b-col
                    >
                    <b-col
                      ><b-btn ref="saveBtn" class="w-100" type="submit" variant="primary" :disabled="campaignId > 0 ? !eloadTopupsModule.access.update : !eloadTopupsModule.access.create"
                        >Save</b-btn
                      ></b-col
                    >
                  </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { digitalLoadMethods, digitalLoadComputed, layoutMethods, erpUserRolesMethods,mopComputed,mopMethods} from '@/state/helpers';
import { ToggleButton } from 'vue-js-toggle-button';
import Swal from "sweetalert2";
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment-timezone';
import { getModuleAccess } from '@/router/helper.js';
import SettingBox from '@/components/BehaviorSetting';
import _ from 'lodash';
import Multiselect from 'vue-multiselect'


export default {
  components: {
    SettingBox,
    ToggleButton,
    DatePicker,
    Multiselect
  },
  props: ['campaignId','mode'],
  page: {
    title: "E-Load Campaign Form",
  },
  data() {
    return {
      rangeOptions: {
        mode: "range",
      },
      ruleObject: {
        required: true
      },
      ruleObject2: {
        required: true,
        min_value:0
      },
      title: "E-Load SKU",
      campaignDetails: {
        campaignId: 0,
        skuId: null,
        promoName: null,
        promoRebate: null,
        promoStartDate: null,
        promoEndDate: null,
        promoRequirement: 'a',
        promoQualifier: '1',
        qualifierStartDate: null,
        qualifierEndDate: null, 
        promoDistribution: ['s'],
        promoStock: null,
        promoFrequency: null,
        promoCap: null,
        segmentName: null,
        behaviorSettings: {
          saveAsPreset: false,
          isUserVerified: true,
          isKankolekUserVerified: false,//Kankolek Verified User
          hasBalanceQualifier: false,
          balanceSetting: {
            minBalance: null,
            maxBalance: null
          },
          hasTopupQualifier: false,
          topupSetting: {
            hasTransactionCount: false,
            hasTransactionAmount: false,
            transactionQualifier: 'd',
            transactionRange: null,
            transactionCountCondition: 'eq',
            transactionCount: null,
            transactionMinCount: null,
            transactionMaxCount: null,
            transactionAmountCondition: 'eq',
            transactionAmount: null,
            transactionMinAmount: null,
            transactionMaxAmount: null,
            woTransactionQualifier: 'd',
            woTransactionRange: null,
            transactionMops:[],
            transactionGrouping: 'all',
          },
          hasRewardsQualifier: false,
          rewardSetting: {
            hasTransactionCount: false,
            hasTransactionAmount: false,
            transactionQualifier: 'd',
            transactionRange: null,
            transactionCountCondition: 'eq',
            transactionCount: null,
            transactionMinCount: null,
            transactionMaxCount: null,
            transactionAmountCondition: 'eq',
            transactionAmount: null,
            transactionMinAmount: null,
            transactionMaxAmount: null,
            woTransactionQualifier: 'd',
            woTransactionRange: null,
            transactionGrouping: 'all',
          },
          hasSellEloadQualifier: false,
          sellEloadSetting: {
            hasTransactionCount: false,
            hasTransactionAmount: false,
            transactionQualifier: 'd',
            transactionRange: null,
            transactionCountCondition: 'eq',
            transactionCount: null,
            transactionMinCount: null,
            transactionMaxCount: null,
            transactionAmountCondition: 'eq',
            transactionAmount: null,
            transactionMinAmount: null,
            transactionMaxAmount: null,
            woTransactionQualifier: 'd',
            woTransactionRange: null,
            transactionGrouping: 'all',
          },
          hasKankolekQualifier: false,
          KankolekSetting: {
            hasTransactionCount: false,
            hasTransactionAmount: false,
            transactionQualifier: 'd',
            transactionRange: null,
            transactionCountCondition: 'eq',
            transactionCount: null,
            transactionMinCount: null,
            transactionMaxCount: null,
            transactionAmountCondition: 'eq',
            transactionAmount: null,
            transactionMinAmount: null,
            transactionType: [
              'send',
              'receive',
              'qr_send',
              'qr_receive',
              'topup',
              'loan_maricash',
              'mk_claimed',
              'maricash_payment'
            ],
            transactionGrouping: 'all',
            transactionMaxAmount: null,
            woTransactionQualifier: 'd',
            woTransactionRange: null
          }
        },
        mopDetailIds:[]
      },
      qualifierOptions: [
        {text: '1 month ago', value: '1'},
        {text: '2 months ago', value: '2'},
        {text: '3 months ago', value: '3'},
        {text: 'Date Range', value: 'r'}
      ],
      conditionOptions: [
        {text: 'greater than or equal', value: 'gte'},
        {text: 'equal to', value: 'eq'}
      ],
      altConditionOptions: [
        {text: 'greater than', value: 'gt'},
        {text: 'greater than or equal', value: 'gte'},
        {text: 'less than', value: 'lt'},
        {text: 'less than or equal', value: 'lte'},
        {text: 'equal to', value: 'eq'},
        {text: 'range', value: 'r'}
      ],
      behavioralOptions: [
        {text: 'Disabled', value: 'd'},
        {text: 'All time', value: '0'},
        {text: '1 month ago', value: '1'},
        {text: '2 months ago', value: '2'},
        {text: '3 months ago', value: '3'},
        {text: 'Date Range', value: 'r'}
      ],
      altBehavioralOptions: [
        {text: 'All time', value: '0'},
        {text: '1 month ago', value: '1'},
        {text: '2 months ago', value: '2'},
        {text: '3 months ago', value: '3'},
        {text: 'Date Range', value: 'r'}
      ],
      eloadTopupsModule: {
        access: {
          create: true,
          update: true,
        }
      },
    }
  },
  methods: {
    ...mopMethods,
    ...digitalLoadMethods,
    ...layoutMethods,
    ...erpUserRolesMethods,
    customize(){
      this.campaignDetails.promoRequirement = 'p';
    },
    updateSettings(){
      var r = this.campaignDetails.promoRequirement;
      var preset = this.segmentPreset[r];
      
      if(r != 'p'){
        this.campaignDetails.behaviorSettings = _.cloneDeep(preset.settings);
        this.campaignDetails.segmentName = preset.name;
        console.log(this.campaignDetails.behaviorSettings);
      }
    },
    goToList(){
      Swal.fire({
        title: "Are you sure?",
        text: `You will want to leave the page?`,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonColor: "#c4297c",
        cancelButtonColor: "#804997",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.$router.push({name:"E-Load Topups", hash: '#campaign'});
        }
      });
      
    },
    checkDistribution(){
      var _this = this;
      setTimeout(() => {
        if(_this.campaignDetails.promoDistribution.includes('s')){
          _this.campaignDetails.promoFrequency = null;
          _this.campaignDetails.promoCap = null;
        } else if(_this.campaignDetails.promoDistribution.includes('f')){
          _this.campaignDetails.promoStock = null;
          _this.campaignDetails.promoCap = null;
        } else if(_this.campaignDetails.promoDistribution.includes('ca')){
          _this.campaignDetails.promoStock = null;
          _this.campaignDetails.promoFrequency = null;
        }
      }, 200)
    },
    save(){
      console.log(this.campaignDetails);
      if(this.campaignDetails.campaignId){
        if(!this.campaignDetails.isDraft){
          Swal.fire({
            title: "Are you sure?",
            text: `You will no longer be able to edit this request?`,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Yes",
          }).then((result) => {
            if (result.value) {
              this.update();
            }
          });
        } else {
          this.update();
        }
      } else {
        if(!this.campaignDetails.isDraft){
          Swal.fire({
            title: "Are you sure?",
            text: `You will no longer be able to edit this request?`,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Yes",
          }).then((result) => {
            if (result.value) {
              this.create();
            }
          });
        } else {
          this.create();
        }
      }
    },
    create(){
      this.createEloadCampaign(this.campaignDetails)
        .then(() => {
          Swal.fire({
            title: this.campaignDetails.isDraft ? "Saved As Draft!" : "Successfully Created!",
            text: `${this.selectedSku} has been created.`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#c4297c",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.$router.push({name:"E-Load Topups", hash: '#campaign'});
            }
          });
        })
        .catch((error) => {
          Swal.fire(
            "Create Failed!",
            `${this.selectedSku}  was not created.<br />${error}`,
            "error"
          );
        });
    },
    onDatePickerClose(data){
      console.log("Length: "+data.length);
      if(data.length != 2){
        this.campaignDetails.qualifierStartDate = null;
        this.campaignDetails.qualifierEndDate = null;
      }
    },
    update(){
      this.updateEloadCampaign(this.campaignDetails)
      .then(() => {
        Swal.fire({
            title: this.campaignDetails.isDraft ? "Saved As Draft!" : "Successfully Updated!",
            text: `${this.selectedSku} has been updated.`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#c4297c",
            confirmButtonText: "OK",
          }).then((result) => {
            if(result.value) {
              this.$router.push({name:"E-Load Topups", hash: '#campaign'});
            }
          });
      })
      .catch((error) => {
          Swal.fire(
            "Save Failed!",
            `${this.selectedSku} was not created.<br />${error}`,
            "error"
          );
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      // console.log(">>>>>>",dirty, validated, valid)
      return dirty || validated ? valid : null;
    },
    saveAsDraft(){
      this.ruleObject.required = false;
      this.campaignDetails.isDraft = true;
      this.$refs.saveBtn.click();
    },
    retrieveMopOpts(){
      this.getMopModuleOpt({module:"eload_wallet"});
    },
    propertyExist(obj,prop){
      return Object.prototype.hasOwnProperty.call(obj, prop)
    },
    turnoffToggleOption(value){
      let index = this.campaignDetails.promoDistribution.indexOf(value);
      if (index !== -1) {
        this.campaignDetails.promoDistribution.splice(index, 1);  // Removes 1 element at the found index
      }
    }
  },
  computed: {
    ...mopComputed,
    ...digitalLoadComputed,
    requirementOptions: {
      get(){
        var options = [];
        this.loadCampaignPresets.forEach(lc => {
          options.push({
            text: lc.name,
            value: lc.id
          })
        });

        options.push({text:'Custom', value:'p'})
        return options;
      }
    },
    segmentPreset: {
      get(){
        var obj = {};
        this.loadCampaignPresets.forEach(lc => {
          obj[lc.id] = lc;
        });

        return obj;
      }
    },
    selectedSegment: {
      get(){
        return 0;
      }
    },
    isNotCustom: {
      get(){
        return this.campaignDetails.promoRequirement !== 'p';
      }
    },
    behavioralRange: {
      get(){
        var start, end, dateRange;
        
        if(this.campaignDetails.qualifierStartDate && this.campaignDetails.qualifierEndDate){
          start = moment(this.campaignDetails.qualifierStartDate).format('YYYY-MM-DD');
          end = moment(this.campaignDetails.qualifierEndDate).format('YYYY-MM-DD');

          if(start == end){
            dateRange = start;
          } else {
            dateRange = start+' to '+end;
          }
        } else if(this.campaignDetails.qualifierStartDate){
          start = moment(this.campaignDetails.qualifierStartDate).format('YYYY-MM-DD');
          dateRange = start;
        } else if(this.campaignDetails.qualifierEndDate){
          end = moment(this.campaignDetails.qualifierEndDate).format('YYYY-MM-DD');
          dateRange = end;
        }

        return dateRange;
      },
      set(dateRange){
        var startDate, endDate;
        if(dateRange.includes('to')){ 
          var dates = dateRange.split(' to ');
          startDate = dates[0] || '';
          endDate = dates[1] || '';
        } else { // Single day
          startDate = dateRange;
          endDate = dateRange;
        }

        this.campaignDetails = Object.assign(this.campaignDetails, {
          qualifierStartDate: startDate,
          qualifierEndDate: endDate
        });
      }
    },
    datePickerEndOptions: {
      get(){
        var opt = {
          minDate: moment(),
          showClear: true,
          useCurrent: false,
          showClose: true,
          timeZone: 'Asia/Manila',
          icons: {
            time: "fa fa-clock",
            clear: "fa fa-trash"
          }
        }

        if(this.campaignDetails.promoStartDate){
          var start = moment(moment(this.campaignDetails.promoStartDate).tz('Asia/Manila').format());
          var current = moment();

          if(start.isAfter(current)){
            opt['minDate'] = start;
            opt['defaultDate'] = start;
          } else {
            opt['minDate'] = moment();
          }
        }

        return opt;
      }
    },
    datePickerStartOptions: {
      get(){
        var opt = {
          maxDate: moment().add(10, 'years'),
          showClear: true,
          useCurrent: false,
          showClose: true,
          timeZone: 'Asia/Manila',
          icons: {
            time: "fa fa-clock",
            clear: "fa fa-trash"
          }
        }

        if(this.campaignDetails.promoEndDate){
          var maxDate = moment(this.campaignDetails.promoEndDate).tz('Asia/Manila').format()
          opt['maxDate'] = moment(maxDate);
        } else {
          opt['maxDate'] = moment().add(10, 'years');
        }
        return opt;
      }
    },
    promoStart: {
      get(){
        var startDate = this.campaignDetails.promoStartDate;
        if(startDate){
          startDate = moment(startDate).tz('Asia/Manila').format();
        }
        return moment(startDate).toDate();
      },
      set(promoStartDate){
        if(promoStartDate){
          console.log("Start date updated");
          this.campaignDetails.promoStartDate = moment(promoStartDate).utc().format();
        } else {
          this.campaignDetails.promoStartDate = null;
        }
      }
    },
    promoEnd: {
      get(){
        var endDate = this.campaignDetails.promoEndDate;
        if(endDate){
          endDate = moment(endDate).tz('Asia/Manila').format();
          if(moment().isAfter(endDate)){
            endDate = moment().tz('Asia/Manila').format();
          } 
        }
        return moment(endDate).toDate();
      },
      set(promoEndDate){
        if(promoEndDate){
          this.campaignDetails.promoEndDate = moment(promoEndDate).utc().format();
        } else {
          this.campaignDetails.promoEndDate = null;
        }
      }
    },
    selectedSku: {
      get(){
        var label = '';
        this.skuOptions.forEach(o => {
          if(o.value == this.campaignDetails.skuId){
            label = o.text;
          }
        });

        return label;
      }
    },
    skuOptions: {
      get(){
        // var options = [{ text: 'Select Eload SKU', value: null}];
        var options = [];

        this.loadTopupsList.forEach(lp => {

          if(lp.skuStatus == 1){
            options.push({
              text: lp.topupName,
              value: lp.topupId
            });
          }
        });
        return options;
      }
    },
    stockOption: {
      get(){
        return this.campaignDetails.promoDistribution.includes('s');
      },
      set(value){
        // this.campaignDetails.promoDistribution = value ? ['s'] : ['f'];
        if(value){
          this.campaignDetails.promoDistribution.push("s")
        }else{
          this.turnoffToggleOption("s")
        }
        if(this.campaignDetails.promoDistribution.length > 0){
          this.turnoffToggleOption("ca")
        }else{
          this.campaignDetails.promoDistribution.push("ca")
        }
        this.checkDistribution();
      }
    },
    frequencyOption: {
      get(){
        return this.campaignDetails.promoDistribution.includes('f');
      },
      set(value){
        // this.campaignDetails.promoDistribution = value ? ['f'] : ['s'];
        if(value){
          this.campaignDetails.promoDistribution.push("f")
        }else{
          this.turnoffToggleOption("f")
        }
        if(this.campaignDetails.promoDistribution.length > 0){
          this.turnoffToggleOption("ca")
        }else{
          this.campaignDetails.promoDistribution.push("ca")
        }
        this.checkDistribution();
      }
    },
    capOption: {
      get(){
        return this.campaignDetails.promoDistribution.includes('ca');
      },
      set(value){
        this.campaignDetails.promoDistribution = value ? ['ca'] : ['s'];
        this.checkDistribution();
      }
    }
  },
  async mounted() {
    this.getEloadCampaignPresets();
    var title = '';
    if(this.mode == 'add'){
      title = 'Add';
    } else if(this.mode == 'edit'){
      title = 'Edit';
    } else if(this.mode == 'duplicate'){
      title = 'Copy';
    }

    this.changeTitle({title: title +' E-Load Campaign'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'Digital Load', to: { name: 'Digital Load'} },
        { text: 'E-Load Topups', to: { name: 'E-Load Topups'} },
        { text: 'E-Load Campaign', to: { name: 'E-Load Campaign'} }
      ]
    });

    // Fetch SKUs
    this.getLoadTopupsList({
      page: 1,
      rows: 99999999
    });
    this.retrieveMopOpts();

    if(this.campaignId > 0){
      this.getEloadCampaignDetails(this.campaignId)
      .then(detail => {
        console.log(detail);
        if(this.mode == 'duplicate'){
          delete detail.campaignId;
          delete detail.campaignStatus;
          detail.promoEndDate = null;
        }
        if(!this.propertyExist(detail.behaviorSettings.topupSetting,"transactionMops")){//check if the added property is exist
          detail.behaviorSettings.topupSetting["transactionMops"] = [];//create property
        }
        if(!this.propertyExist(detail.behaviorSettings,"hasKankolekQualifier")){//check if the added property is exist
          detail.behaviorSettings["hasKankolekQualifier"] = false;//create property
        }
        if(!this.propertyExist(detail.behaviorSettings,"KankolekSetting")){//check if the added property is exist
          detail.behaviorSettings["KankolekSetting"] = this.campaignDetails.behaviorSettings.KankolekSetting;//create property
        }
        this.campaignDetails = detail;
        this.campaignDetails.skuId = this.campaignDetails.skuId.map(i => {
          return { 
            text: i.name, 
            value: i.id 
          }
        })
      })
      .catch((e)=>{
          Swal.fire(
            "Update Failed!",
            e,
            "error"
          );
          this.$router.push({name:"E-Load Topups", hash: '#campaign'});
      });
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'eLoad', 'eLoad Topups')
      .then((access) => this.eloadTopupsModule.access = access);
      
  },
};
</script>

<style>
.red {
  color: #FF0000;
}

.draft-link {
  text-decoration: underline;
  font-weight: bold;
  color: #c4297c;
  cursor: pointer;
}

.subsetting {
  border: 1px solid #ACACAC;
}

.disable-setting {
  pointer-events: none;
  opacity: 0.5
}

.multiselect__tag {
  background: #E83092;
}
.multiselect__tag-icon:after,
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  color: #fff !important;
  background: none;
}
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.invalid ~ .invalid-feedback {
  display: block;
}
</style>
